import React from 'react';
import { useQuery } from '@apollo/client';
import {
  CompositeNavigationProp,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import { RouteProp } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import Snackbar from '~/components/Snackbar';
import { useAuth } from '~/context/auth';
import { Group } from '~/data/models/group';
import { GROUP } from '~/data/operations/group';
import { GroupStackParamList, RootStackParamList } from '~/navigation/types';
import { getInviteUrl } from '~/utils/helpers';
import { shareText } from '~/utils/index';
import CreateGroupSuccessLayout from './layout';

type CreateGroupSuccessNavProp = CompositeNavigationProp<
  StackNavigationProp<RootStackParamList>,
  StackNavigationProp<GroupStackParamList, 'CreateGroupSuccess'>
>;
type CreateGroupSuccessRouteProp = RouteProp<
  GroupStackParamList,
  'CreateGroupSuccess'
>;

export default function CreateGroupSuccess(): JSX.Element {
  const navigation = useNavigation<CreateGroupSuccessNavProp>();
  const {
    params: { groupId },
  } = useRoute<CreateGroupSuccessRouteProp>();

  const { onLogout } = useAuth();

  const { data: groupData } = useQuery(GROUP, {
    variables: {
      id: groupId,
    },
  });

  const group = groupData?.group as Group;

  const onShare = async () => {
    try {
      const url =
        group && group.token ? getInviteUrl(group.id, group.token) : '';
      shareText(url);
    } catch (e) {
      if (e instanceof Error) {
        Snackbar.show(e.message);
      }
    }
  };

  const logoutHandler = async () => {
    await onLogout();

    navigation.reset({
      routes: [{ name: 'AuthStack' }],
    });
  };

  return (
    <CreateGroupSuccessLayout
      avatar={group?.avatar || group?.icon?.icon || ''}
      onBack={() => navigation.goBack()}
      onStartPlaning={() => {
        //hack to pop from GroupStack back to Main
        navigation.popToTop();
        navigation.goBack();
      }}
      onShareInvite={() => onShare()}
      onLogout={logoutHandler}
    />
  );
}

/**
 * TODO:
 * - Extract invite url logic
 */
